<template>
    <div class="services-contacts view">
        <div class="contacts">
            <div class="contact" v-for="contact in contacts">
                <div class="container">
                    <div class="profil"><img :src="contact.imgSrc" alt=""></div>
                    <div class="name" v-text="contact.name"></div>
                    <div class="skills" v-if="contact.skills" v-text="contact.skills"></div>
                    <div class="coordinates">
                        <a v-text="contact.coordinates.phone" :href="'tel:' + contact.coordinates.phone"></a>
                        <a v-text="contact.coordinates.mobile" :href="'tel:' + contact.coordinates.mobile"></a>
                        <a v-text="contact.coordinates.mail" :href="'mailto:' + contact.coordinates.mail"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                contacts: ""
            }
        },
        created() {
            this.contacts = this.$store.state.contacts;
            console.log(this.contacts);
        },
        mounted() {
            //initialisation de slick js
            //carousel sur les actions
            // $('.contacts').slick({
            //     arrows: false,
            //     dots: true,
            //     infinite: false
            // });
        }
    }
</script>


// WEBPACK FOOTER //
// Contacts.vue?7b84a717